// extracted by mini-css-extract-plugin
export default {"DataTable":"DeleteUser_DataTable__jpDSo","ButtonSearch":"DeleteUser_ButtonSearch__9nQ2C","ButtonSeeMore":"DeleteUser_ButtonSeeMore__y9ZDT"};